import img0 from '../img/ralsei.webp'
import img1 from '../img/frog.png'
import img2 from '../img/tree.png'
import img3 from '../img/ralsei2.webp'
import img4 from '../img/chocobo.webp'
import img5 from '../img/pg1.png'

export let sprites = [img0, img1, img2, img3, img4, img5]